import axios from 'axios';
import {checkErrors} from './errors';

export const LOADAMENITIES_REQUESTED = 'amenities/LOADAMENITIES_REQUESTED';
export const LOADAMENITIES_FINISHED = 'amenities/LOADAMENITIES_FINISHED';
export const SETAMENITIES = 'amenities/SETAMENITIES';

export const ADDAMENITY_REQUESTED = 'amenities/ADDAMENITY_REQUESTED';
export const ADDAMENITY_FINISHED = 'amenities/ADDAMENITY_FINISHED';

export const EDITAMENITY_REQUESTED = 'amenities/EDITAMENITY_REQUESTED';
export const EDITAMENITY_FINISHED = 'amenities/EDITAMENITY_FINISHED';

export const REMOVEAMENITY_REQUESTED = 'amenities/REMOVEAMENITY_REQUESTED';
export const REMOVEAMENITY = 'amenities/REMOVEAMENITY';
export const REMOVEAMENITY_FINISHED = 'amenities/REMOVEAMENITY_FINISHED';

export const LOADAMENITY_REQUESTED = 'amenities/LOADAMENITY_REQUESTED';
export const LOADAMENITY_FINISHED = 'amenities/LOADAMENITY_FINISHED';

export const LOADAMENITIESASSIGNMENTS_REQUESTED = 'amenities/LOADAMENITIESASSIGNMENTS_REQUESTED';
export const LOADAMENITIESASSIGNMENTS_FINISHED = 'amenities/LOADAMENITIESASSIGNMENTS_FINISHED';
export const SETAMENITIESASSIGNMENTS = 'amenities/SETAMENITIESASSIGNMENTS';

export const ADDAMENITIESASSIGNMENTS_REQUESTED = 'amenities/ADDAMENITIESASSIGNMENTS_REQUESTED';
export const ADDAMENITIESASSIGNMENTS_FINISHED = 'amenities/ADDAMENITIESASSIGNMENTS_FINISHED';

export const REMOVEAMENITYASSIGNMENT_REQUESTED = 'amenities/REMOVEAMENITYASSIGNMENT_REQUESTED';
export const REMOVEAMENITYASSIGNMENT_FINISHED = 'amenities/REMOVEAMENITYASSIGNMENT_FINISHED';

const initialState = {
  amenities: [],
  total: 0,
  limit: 1000,
  skip: 0,
  isLoadingAmenities: false,
  isAddingAmenity: false,
  isEditingAmenity: false,
  isRemovingAmenity: false,
  isLoadingAmenity: false,
  amenitiesassignments: [],
  isLoadingAmenitiesAssignments: false,
  isAddingAmenitiesAssignments: false,
  isRemovingAmenitiesAssignments: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOADAMENITIES_REQUESTED:
    return {
      ...state,
      isLoadingAmenities: true
    };

  case LOADAMENITIES_FINISHED:
    return {
      ...state,
      isLoadingAmenities: false
    };

  case SETAMENITIES:
    
    return {
      ...state,
      amenities: action.amenities
    };
  
    case ADDAMENITY_REQUESTED:
    return {
      ...state,
      isAddingAmenity: true
    };

  case ADDAMENITY_FINISHED:
    return {
      ...state,
      isAddingAmenity: false
    };
  
  case EDITAMENITY_REQUESTED:
    return {
      ...state,
      isEditingAmenity: true
    };

  case EDITAMENITY_FINISHED:
    return {
      ...state,
      isEditingAmenity: false
    };

  case REMOVEAMENITY:
    return {
      ...state,
      amenities: action.amenities
    };

  case REMOVEAMENITY_REQUESTED:
    return {
      ...state,
      isRemovingAmenity: true,
    };

  case REMOVEAMENITY_FINISHED:
    return {
      ...state,
      isRemovingAmenity: false
    };
  
  case LOADAMENITY_REQUESTED:
    return {
      ...state,
      isLoadingAmenity: true
    };

  case LOADAMENITY_FINISHED:
    return {
      ...state,
      isLoadingAmenity: false
    };

  case LOADAMENITIESASSIGNMENTS_REQUESTED:
    return {
      ...state,
      isLoadingAmenitiesAssignments: true
    };

  case LOADAMENITIESASSIGNMENTS_FINISHED:
    return {
      ...state,
      isLoadingAmenitiesAssignments: false
    };

  case SETAMENITIESASSIGNMENTS:
    
    return {
      ...state,
      amenitiesassignments: action.amenitiesassignments
    };

  case ADDAMENITIESASSIGNMENTS_REQUESTED:
    return {
      ...state,
      isAddingAmenitiesAssignments: true
    };

  case ADDAMENITIESASSIGNMENTS_FINISHED:
    return {
      ...state,
      isAddingAmenitiesAssignments: false
    };

  case REMOVEAMENITYASSIGNMENT_REQUESTED:
    return {
      ...state,
      isRemovingAmenitiesAssignments: true
    };

  case REMOVEAMENITYASSIGNMENT_FINISHED:
    return {
      ...state,
      isRemovingAmenitiesAssignments: false
    };

  default:
    return state;
  }
};


export const loadAmenities = () => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADAMENITIES_REQUESTED
    });

    axios.get(`${window.endpoint}/amenities`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      
      dispatch({
        type: SETAMENITIES,
        amenities: response.data.amenities
      });
      
      dispatch({
        type: LOADAMENITIES_FINISHED
      });
      
    })
    
  };
};

export const addAmenity = (data, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: ADDAMENITY_REQUESTED
    });

    axios.post(`${window.endpoint}/amenities`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: ADDAMENITY_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editAmenity = (id, data, cb) => {
  return (dispatch, getState) => {
    

    dispatch({
      type: EDITAMENITY_REQUESTED
    });

    axios.post(`${window.endpoint}/amenities/${id}`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: EDITAMENITY_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeAmenity = (id, cb) => {
  return (dispatch, getState) => {

    const amenitiesState = getState().amenities;

    dispatch({
      type: REMOVEAMENITY_FINISHED
    });

    axios.delete(`${window.endpoint}/amenities/${id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVEAMENITY,
        amenities: amenitiesState.amenities.filter((amenity) => amenity.amenity_id !== id)
      });
      
      dispatch({
        type: REMOVEAMENITY_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadAmenity = (kiosk_id, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADAMENITY_REQUESTED
    });

    axios.get(`${window.endpoint}/amenities/${kiosk_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: LOADAMENITY_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadAmenitiesAssignments = (cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADAMENITIESASSIGNMENTS_REQUESTED
    });

    axios.get(`${window.endpoint}/amenitiesassignments`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      
      dispatch({
        type: SETAMENITIESASSIGNMENTS,
        amenitiesassignments: response.data.amenitiesassignments
      });

      dispatch({
        type: LOADAMENITIESASSIGNMENTS_FINISHED
      });

      if (cb instanceof Function) { cb(); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addAmenitiesAssignments = ({amenity_id, coordinate_x, coordinate_y, floor_plan_id}, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: ADDAMENITIESASSIGNMENTS_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ amenity_id, coordinate_x, coordinate_y, floor_plan_id, is_active: 1 }));

    axios.post(`${window.endpoint}/amenitiesassignments`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      if (cb instanceof Function) { cb(); }
      
      dispatch({
        type: ADDAMENITIESASSIGNMENTS_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeAmenityAssignment = (amenityAssignmentID, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: REMOVEAMENITYASSIGNMENT_REQUESTED
    });

    axios.delete(`${window.endpoint}/amenitiesassignments/${amenityAssignmentID}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      if (cb instanceof Function) { cb(); }
      
      dispatch({
        type: REMOVEAMENITYASSIGNMENT_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
}


// WEBPACK FOOTER //
// ./src/reducers/amenities.js